import {useQuery} from "@tanstack/react-query";
import {GetRewardConfigsResponse, RewardsApi, Token} from "@devour/client";
import getConfig from "@/utils/getConfig";

async function fetchRewardConfigs(fullToken: Token, rewardConfigIds: Array<string>): Promise<GetRewardConfigsResponse> {
    return await new RewardsApi(getConfig(fullToken)).getRewardConfigs({
        ids: rewardConfigIds,
        limit: rewardConfigIds.length,
    });
}

function rewardConfigsQuery(fullToken: Token, rewardConfigIds: Array<string>) {
    const enabled = Boolean(rewardConfigIds && rewardConfigIds.length > 0);
    const sortedRewardConfigIds = rewardConfigIds ? [...rewardConfigIds].sort() : [];

    return {
        queryKey: [
            "get-reward-configs",
            fullToken?.id ?? "unauthenticated",
            ...sortedRewardConfigIds,
        ],
        queryFn: () => fetchRewardConfigs(fullToken, sortedRewardConfigIds),
        keepPreviousData: true,
        staleTime: 60000,
        refetchOnWindowFocus: false,
        enabled: enabled,
    } as const;
}

export function useGetRewardConfigs(fullToken: Token, rewardConfigIds: Array<string>) {
    return useQuery(rewardConfigsQuery(fullToken, rewardConfigIds));
}
